import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { IoMdCall } from "react-icons/io";
import {
  FaChevronCircleLeft,
} from "react-icons/fa";
import { FaCircleChevronRight } from "react-icons/fa6";
import { IoSearch } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import {
  useToast,
} from '@chakra-ui/react';
import { FiUser } from "react-icons/fi";
const PAGE_SIZE = 10;

export default function CallTransactions() {
  const navigate = useNavigate();
  const toast = useToast();

  // ================= CALL TRANSACTIONS STATE =================

  const [transactions, setTransactions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalTransactions, setTotalTransactions] = useState(0);
  const [stats, setStats] = useState(null);



  const [search, setSearch] = useState("");
  const [callTypeFilter, setCallTypeFilter] = useState("all");
  const [statusFilter, setStatusFilter] = useState("all");
  const [error, setError] = useState(null);

  const [users, setUsers] = useState([]);
  const [userSearch, setUserSearch] = useState("");
  const [userSearchTimeout, setUserSearchTimeout] = useState(null);
  const [userPage, setUserPage] = useState(1);
  const [userTotalPages, setUserTotalPages] = useState(1);
  const [userLastCalls, setUserLastCalls] = useState({}); // { userId: { personName, duration, callType, date } }
const[overview,setOverview]=useState('');
  // ================= CALL TRANSACTIONS FETCH =================
  const fetchCallTransactions = useCallback(
    async (page = 1) => {

      setError(null);
      try {
        const params = { page, limit: PAGE_SIZE };
        if (search && search.trim()) params.search = search.trim();
        if (callTypeFilter && callTypeFilter !== "all")
          params.callType = callTypeFilter;
        if (statusFilter && statusFilter !== "all")
          params.status = statusFilter;

        const res = await axios.get(
          "/api/v1/app/call-transactions/history",
          { params }
        );



        if (res?.data?.status === "OK" && res.data.data) {
          const data = res.data.data;
          setTransactions(data.transactions || []);
          setCurrentPage(data.currentPage || page);
          setTotalPages(data.totalPages || 1);
          setTotalTransactions(data.totalTransactions ?? 0);
        } else {
          if (Array.isArray(res?.data)) {
            setTransactions(res.data);
            setCurrentPage(1);
            setTotalPages(1);
            setTotalTransactions(res.data.length);
          } else {
            setTransactions([]);
            setCurrentPage(1);
            setTotalPages(1);
            setTotalTransactions(0);
          }
        }
      } catch (err) {
        console.error("Error fetching call transactions:", err);
        setError("Failed to load transactions");
      } finally {

      }
    },
    [search, callTypeFilter, statusFilter]
  );

  const fetchCallStats = async () => {
  try {
    const res = await axios.get(
      "/api/v1/app/call-transactions/call-stats"
    );

    if (res.data.success) {
      setStats(res.data.data);
    }
  } catch (err) {
    console.error("Error fetching stats:", err);
  }
};


  const exportToExcel = async () => {
    try {
      const params = {};
      if (search && search.trim()) params.search = search.trim();
      if (callTypeFilter !== "all") params.callType = callTypeFilter;
      if (statusFilter !== "all") params.status = statusFilter;

      const res = await axios.get(
        "/api/v1/app/call-transactions/export-xls",
        {
          params,
          responseType: "blob",
        }
      );

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "call-history.xlsx");
      document.body.appendChild(link);
      link.click();
    } catch (err) {
      console.error("❌ XLS export failed", err);
    }
  };
  useEffect(() => {
    fetchCallTransactions(currentPage);
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  useEffect(()=>{
fetchCallTransactions(currentPage);
  },[fetchCallTransactions])

  useEffect(()=>{
fetchCallStats();
  },[])
  
// const fetchOverview= async()=>{
//   const overviewRes = await axios.get("/api/v1/app/coin-earnings/overview");
//       if (overviewRes.data.status === "OK") {
//         setOverview(overviewRes.data.data || null);
//       }
// }


  // ================= USER LIST FETCH (COIN EARNING USER BLOCK) =================
  const fetchUsers = useCallback(
    async (pageNumber = userPage, searchQuery = userSearch) => {
      try {
        //new api getusersByCallHistroy
        const res = await axios.get("api/v1/user/getusersByCallHistroy", {
          params: {
            page: pageNumber,
            limit: 10,
            search: searchQuery ? searchQuery : undefined,
          },
        });

        if (res.data.success) {
          setUsers(res.data.data || []);
          setUserTotalPages(res.data.pagination.totalPages || 1);
        } else {
          setUsers([]);
          setUserTotalPages(1);
        }
      } catch (err) {
        console.error("Error fetching users:", err);
      }
    },
    [userPage, userSearch]
  );

  useEffect(() => {
    fetchUsers(userPage, userSearch);
  }, [fetchUsers, userPage, userSearch]);

  // Fetch last call details for each user
  useEffect(() => {
    const fetchLastCalls = async () => {
      if (users.length === 0) return;
      
      const lastCallPromises = users.map(async (user) => {
        try {
          const res = await axios.get(
            `/api/v1/app/call-transactions/getCallHistory/${user._id}`,
            { params: { page: 1, limit: 1 } }
          );

          if (res.data.status === "OK" && res.data.data?.transactions?.length > 0) {
            const lastCall = res.data.data.transactions[0];
            const currentUserId = user._id;
            
            // Determine the other person (caller or receiver)
            let otherPerson = null;
            if (lastCall.callerId && String(lastCall.callerId._id) === String(currentUserId)) {
              otherPerson = lastCall.receiverId;
            } else if (lastCall.receiverId && String(lastCall.receiverId._id) === String(currentUserId)) {
              otherPerson = lastCall.callerId;
            }

            return {
              userId: user._id,
              data: {
                personName: otherPerson?.fullName || otherPerson?.name || "—",
                duration: lastCall.durationMinutes || 0,
                callType: lastCall.callType || "—",
                date: lastCall.callStartTime || lastCall.createdAt || null,
              }
            };
          }
          return { userId: user._id, data: null };
        } catch (err) {
          console.error(`Error fetching last call for user ${user._id}:`, err);
          return { userId: user._id, data: null };
        }
      });

      const results = await Promise.all(lastCallPromises);
      const lastCallsMap = {};
      results.forEach(({ userId, data }) => {
        if (data) {
          lastCallsMap[userId] = data;
        }
      });
      setUserLastCalls(lastCallsMap);
    };

    fetchLastCalls();
  }, [users]);

  const handleUserSearchChange = (value) => {
    setUserSearch(value);
    if (userSearchTimeout) clearTimeout(userSearchTimeout);

    const newTimeout = setTimeout(() => {
      setUserPage(1);
      fetchUsers(1, value);
    }, 800);
    setUserSearchTimeout(newTimeout);
  };


  return (
    <div className="min-h-screen p-6 bg-white text-[var(--black-text)]">
      {/* Header / Title */}
      <div className="flex items-start justify-between mb-6">
        <div>
          <h1 className="text-3xl font-extrabold text-[var(--primary-solid)] flex items-center gap-3">
            <span className="text-3xl">
              <IoMdCall />
            </span>
            <span>Call Transactions</span>
          </h1>
          <p className="text-sm text-[var(--black-text)]/70 mt-1">
            Monitor and manage all call transactions and earnings
          </p>
        </div>

        <div className="flex items-center gap-3">
          <button
            onClick={exportToExcel}
            className="px-4 py-2 bg-white border-2 border-gray-200 rounded-lg text-[var(--black-text)] text-sm flex items-center gap-2 hover:bg-gradient-to-r hover:from-[var(--primary-solid)] hover:to-[var(--primary-dark)] hover:text-white transition"
          >
            ⤓ Export XLS
          </button>
        </div>
      </div>

      {/* Metric cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        <div className="bg-gradient-to-br from-[var(--yellow)]/10 to-[var(--yellow)]/5 border-2 border-[var(--yellow)]/20 rounded-xl p-4 shadow-lg">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs font-medium text-[color:var(--yellow)/0.8] uppercase tracking-wider">
                Total Transactions
              </p>
              <p className="text-2xl font-bold text-[var(--yellow)]">
                {stats?.totalTransactions || 0}
              </p>
            </div>
            <div className="text-3xl text-[var(--yellow)]">
              <IoMdCall />
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-green-500/10 to-green-500/5 border-2 border-green-500/20 rounded-xl p-4 shadow-lg">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs font-medium text-green-400 uppercase tracking-wider">
                Voice Call Coins
              </p>
              <p className="text-2xl font-bold text-green-400">
                {stats?.totalVoiceCoins || 0}
              </p>
              <p className="text-xs text-green-300 mt-1">total earned</p>
            </div>
            <div className="text-3xl text-green-400">
              <FiUser />
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-blue-500/10 to-blue-500/5 border-2 border-blue-500/20 rounded-xl p-4 shadow-lg">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs font-medium text-blue-400 uppercase tracking-wider">
                Video Call Coins
              </p>
              <p className="text-2xl font-bold text-blue-400">
                {stats?.totalVideoCoins  || 0}
              </p>
              <p className="text-xs text-blue-300 mt-1">total earned</p>
            </div>
            <div className="text-3xl text-blue-400">
              <IoMdCall />
            </div>
          </div>
        </div>
      </div>

      {/* ======= USER LIST BLOCK (COIN EARNINGS STYLE) ======= */}
      <div className="bg-white p-6 rounded-xl shadow-sm mb-8 border-2 border-gray-200">
        {/* TOP ROW */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <div>
            <h2 className="text-xl font-bold text-[var(--primary-solid)]">
              Users Call History
            </h2>
            <p className="text-[var(--black-text)]/70">
              Overview of Users  Call History
            </p>
          </div>

          {/* SEARCH */}
          <div className="relative w-full md:w-72">
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--primary-solid)] text-xl">
              <IoSearch />
            </span>

            <input
              type="text"
              placeholder="Search users ..."
              value={userSearch}
              onChange={(e) => handleUserSearchChange(e.target.value)}
              className="w-full pl-10 pr-4 py-2 rounded-xl border-2 border-gray-200 bg-white text-[var(--black-text)] 
                            placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[var(--primary-solid)]/50 focus:border-[var(--primary-solid)] 
                            focus:ring-2 focus:ring-[var(--yellow)]"
            />
          </div>
        </div>

        {/* USER LIST */}
        <div className="mt-4">
          {users.length === 0 ? (
            <p className="text-center text-gray-400 py-6">No users found</p>
          ) : (
            users.map((user) => {
              // Format duration helper
              const formatDuration = (minutes) => {
                if (!minutes && minutes !== 0) return "—";
                if (minutes < 1) return "< 1 min";
                if (minutes < 60) return `${Math.round(minutes)} min`;
                const hours = Math.floor(minutes / 60);
                const mins = Math.round(minutes % 60);
                return mins > 0 ? `${hours}h ${mins}m` : `${hours}h`;
              };

              // Format date helper
              const formatDate = (dateString) => {
                if (!dateString) return "—";
                try {
                  const date = new Date(dateString);
                  const now = new Date();
                  const diffMs = now - date;
                  const diffMins = Math.floor(diffMs / 60000);
                  const diffHours = Math.floor(diffMins / 60);
                  const diffDays = Math.floor(diffHours / 24);

                  if (diffMins < 1) return "Just now";
                  if (diffMins < 60) return `${diffMins} min ago`;
                  if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
                  if (diffDays < 7) return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
                  return date.toLocaleDateString();
                } catch {
                  return "—";
                }
              };

              // Get last call details from state
              const lastCall = userLastCalls[user._id];
              const lastSpokenPerson = lastCall?.personName || "—";
              const lastCallDuration = lastCall?.duration || null;
              const lastCallType = lastCall?.callType || "—";
              const lastCallDate = lastCall?.date || null;

              return (
                <div
                  onClick={() =>
                    navigate(`/call-transactions/${user._id}`)
                  }
                  key={user._id}
                  className="border-2 border-gray-200 rounded-xl p-4 mb-4 shadow-sm bg-white
                                    hover:border-[var(--primary-solid)] hover:border-2 transition cursor-pointer"
                >
                  <div className="flex items-center gap-4">
                    {/* <div className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center flex-shrink-0">
                      <FiUser className="text-white" />
                    </div> */}

                    <div className="w-10 h-10 rounded-full overflow-hidden border border-gray-200 bg-gray-100 flex items-center justify-center">
    {user.profileImage && user.profileImage !== "default-profile.jpg" ? (
        <img
            src={user.profileImage}
            alt={user.fullName}
            className="w-full h-full object-cover"
            onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/default-avatar.png"; // optional fallback
            }}
        />
    ) : (
        <FiUser className="text-gray-500 text-xl" />
    )}
</div>


                    <div className="flex-1 min-w-0">
                      <p className="font-bold text-[var(--black-text)] text-lg">
                        {user.fullName || "N/A"}
                      </p>
                      <p className="text-[var(--black-text)]/70 text-sm">
                        {user.phoneNumber}
                      </p>
                    </div>

                    {/* Last Call Details */}
                    {lastCall ? (
                      <div className="text-right flex-shrink-0">
                        <div className="text-sm text-[var(--black-text)]/80">
                          <span className="font-medium">Last spoken: </span>
                          <span className="text-[var(--primary-solid)]">{lastSpokenPerson}</span>
                        </div>
                        <div className="text-sm text-[var(--black-text)]/70 mt-1">
                          <span className="font-medium">Duration: </span>
                          <span>{formatDuration(lastCallDuration)}</span>
                        </div>
                        <div className="text-xs text-[var(--black-text)]/60 mt-1 flex items-center justify-end gap-2">
                          <span className="capitalize">{lastCallType}</span>
                          {lastCallDate && (
                            <>
                              <span>•</span>
                              <span>{formatDate(lastCallDate)}</span>
                            </>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="text-right flex-shrink-0">
                        <div className="text-sm text-[var(--black-text)]/60">
                          No call history
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              );
            })
          )}
        </div>

        {/* USER PAGINATION */}
        <div className="flex items-center justify-center mt-8">
          <div className="flex items-center gap-2 bg-white border-2 border-gray-200 px-4 py-3 rounded-xl shadow-sm">
            <button
              disabled={userPage === 1}
              onClick={() => setUserPage(userPage - 1)}
              className="px-3 py-2 rounded-lg text-sm font-semibold transition bg-[var(--yellow)] text-[var(--black)]
                        disabled:opacity-40 disabled:cursor-not-allowed hover:opacity-80"
            >
              <FaChevronCircleLeft />
            </button>

            <div className="flex items-center gap-2">
              {(() => {
                let pages = [];
                const createPageBtn = (p) => (
                  <button
                    key={p}
                    onClick={() => setUserPage(p)}
                    className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-semibold border transition 
                                        ${p === userPage
                        ? "bg-gradient-to-r from-[var(--primary-solid)] to-[var(--primary-dark)] text-white border-gray-200"
                        : "text-[var(--black-text)] border-2 border-gray-200 hover:bg-gradient-to-r hover:from-[var(--primary-solid)] hover:to-[var(--primary-dark)] hover:text-white"
                      }`}
                  >
                    {p}
                  </button>
                );

                const createDot = (key) => (
                  <span
                    key={key}
                    className="text-[var(--primary-solid)] font-bold px-2"
                  >
                    …
                  </span>
                );

                if (userTotalPages <= 7) {
                  for (let i = 1; i <= userTotalPages; i++)
                    pages.push(createPageBtn(i));
                } else {
                  pages.push(createPageBtn(1));
                  pages.push(createPageBtn(2));

                  if (userPage > 4) pages.push(createDot("start"));

                  let start = Math.max(3, userPage - 1);
                  let end = Math.min(userTotalPages - 2, userPage + 1);

                  for (let i = start; i <= end; i++)
                    pages.push(createPageBtn(i));

                  if (userPage < userTotalPages - 3)
                    pages.push(createDot("end"));

                  pages.push(createPageBtn(userTotalPages - 1));
                  pages.push(createPageBtn(userTotalPages));
                }

                return pages;
              })()}
            </div>

            <button
              disabled={userPage === userTotalPages}
              onClick={() => setUserPage(userPage + 1)}
              className="px-3 py-2 rounded-lg text-sm font-semibold transition bg-[var(--yellow)] text-[var(--black)]
                        disabled:opacity-40 disabled:cursor-not-allowed hover:opacity-80"
            >
              <FaCircleChevronRight />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}


